import { PresentationWithId } from "../interfaces/IPresentations";
import { useEffect, useState } from "react";
import { usePresentationsContext } from "../contexts/PresentationsContext";

export const usePresentation = (presentationId: string) => {
  const { presentations, handlePresentationUpdate } = usePresentationsContext();
  const [presentation, setPresentation] = useState<PresentationWithId | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        if (presentations && presentationId) {
          // Pobieramy jedną prezentację
          const presentation = presentations.find(
            (presentation) => presentation.id === presentationId
          );
          setPresentation(presentation ? presentation : null);
        }
      } catch (error) {
        console.error("Błąd podczas pobierania prezentacji:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [presentations, presentationId]);

  return {
    presentations,
    presentation,
    isLoading,
    updatePresentation: handlePresentationUpdate,
  };
};
